module.exports = "/assets/96b8d5f47051efb91243fd008c951d7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/5Y.png
// module id = 2206
// module chunks = 0